import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPageKey } from '../../utils/keys';
export const usePage = (options) => {
    const { variables, fields, useQueryOptions } = options;
    const { client } = useTribeClient();
    const pageKey = getPageKey(variables);
    return useQuery(pageKey, () => client.spaces.getByPath(variables, fields), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=usePage.js.map